import type { ICellRendererParams } from 'ag-grid-community';
import type { UiString } from '../../schema';

// Same tonal pill as features/tags — co-located here to keep ui-strings
// self-contained. If a third feature needs it, promote to src/components/ui/.
export function ActiveBadge(p: ICellRendererParams<UiString, boolean>) {
  const active = p.value ?? p.data?.isActive;
  if (active === undefined) return null;
  const styles = active
    ? { label: 'Active', bg: 'bg-success/15', text: 'text-success', dot: 'bg-success' }
    : { label: 'Inactive', bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning' };
  return (
    <span
      className={[
        'inline-flex w-fit shrink-0 items-center gap-1.5 self-center rounded-full px-2 py-[3px]',
        'text-[10px] font-black uppercase leading-none tracking-tight',
        styles.bg,
        styles.text,
      ].join(' ')}
    >
      <span aria-hidden className={`h-1.5 w-1.5 shrink-0 rounded-full ${styles.dot}`} />
      <span>{styles.label}</span>
    </span>
  );
}
